const toggleModal = (target) => {
  if ($('body').css('overflow') == 'hidden') {
    $('body').css('overflow', '');
  } else {
    $('body').css('overflow', 'hidden');
  }

  if ($(window).width() > 992) {
    if ($('.active-modal').length) {
      $(target).toggleClass('active-modal');
      $('.app-layer').fadeOut('shown-modal');
      $('body').toggleClass('shown-modal');
      // if($(target).hasClass('modal--big')) {
      //     $('body').toggleClass('shown-modal');
      // }else{
      //     setTimeout(function() {
      //         $('body').toggleClass('shown-modal');
      //     }, 400);
      // }
    } else {
      $('.app-layer').fadeIn('shown-modal');
      $('body').toggleClass('shown-modal');
      if ($(target).hasClass('modal--big')) {
        $(target).toggleClass('active-modal');
      } else {
        setTimeout(function () {
          $(target).toggleClass('active-modal');
        }, 400);
      }
    }
  } else {
    $(target).toggleClass('active-modal');
    if ($('.active-modal').length) {
      $('.app-layer').fadeOut('shown-modal');
    } else {
      $('.app-layer').fadeIn('shown-modal');
    }
    $('body').toggleClass('shown-modal');
  }

  $('.btn').blur();
};

$(document).on('click', '[data-modal]', function () {
  const unique = $(this).attr('data-modal-unique');
  $('.modal--big .modal__close').css(
    'left',
    $('.header__content__toggle').offset().left
  );

  const target = $(this).data('modal');
  if (unique) {
    toggleModal('#modal--' + target + unique);
  } else {
    toggleModal('#modal--' + target);
  }

  var video = $('#modal--videoModal');
  if (target == 'videoModal') {
    video.find('video').get(0).play();
  }

  if (!target.length) {
    return;
  }
});

$(window).on('resize', function () {
  $('.modal--big .modal__close').css(
    'left',
    $('.header__content__toggle').offset().left
  );
});

$('.modal__close').on('click', function () {
  var video = $('#modal--videoModal');
  if (video.length) {
    video.find('video').get(0).pause();
  }
  let modal = $(this).parent();
  toggleModal(modal);
});

$(document).keydown(function (e) {
  if (e.keyCode == 27) {
    if ($('.active-modal').length != 0) {
      var video = $('#modal--videoModal');
      if (video.length) {
        video.find('video').get(0).pause();
      }
      toggleModal('.active-modal');
    }
  }
});
